var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React, { useMemo } from "react";
import styled from "styled-components";
import { RatingOverview } from "..";
var OverviewWrapper = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: auto auto;\n  column-gap: .5rem;\n  justify-content: left;\n  align-items: center;\n  color: ", ";\n  padding: 1rem;\n"], ["\n  display: grid;\n  grid-template-columns: auto auto;\n  column-gap: .5rem;\n  justify-content: left;\n  align-items: center;\n  color: ", ";\n  padding: 1rem;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var Title = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  font-weight: bold;\n  font-size: 1rem;\n  color: ", ";\n"], ["\n  margin: 0;\n  padding: 0;\n  font-weight: bold;\n  font-size: 1rem;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colorContent();
});
var Image = styled.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 150px;\n  height: 130px;\n  grid-row: 1 / 3;\n"], ["\n  width: 150px;\n  height: 130px;\n  grid-row: 1 / 3;\n"])));
var ReviewOverview = function (_a) {
    var image = _a.image, reviews = _a.reviews, title = _a.title;
    var ratings = useMemo(function () {
        return reviews.reduce(function (acc, curr) {
            acc[curr.rating]++;
            return acc;
        }, {
            1: 0,
            2: 0,
            3: 0,
            4: 0,
            5: 0,
        });
    }, [reviews]);
    return (React.createElement(OverviewWrapper, null,
        React.createElement(Title, null, title),
        React.createElement(Image, { src: image }),
        React.createElement(RatingOverview, { ratings: ratings })));
};
export default ReviewOverview;
var templateObject_1, templateObject_2, templateObject_3;
